const state = {
    userID: localStorage.getItem('user-id') || null,
    userManager: localStorage.getItem('user-manager') || null,
    userMarketingTask: localStorage.getItem('user-marketing-task') || null,
    userMarketingTaskSchedule: localStorage.getItem('user-marketing-task-schedule') || null,
    userRoot: localStorage.getItem('user-root') || null,
    userTask: localStorage.getItem('user-task') || null,
    userTaskSchedule: localStorage.getItem('user-task-schedule') || null,
}

const getters = {
    user (state) {
        return {
            id: state.userID,
            manager: state.userManager,
            marketingTask: state.userMarketingTask,
            marketingTaskSchedule: state.userMarketingTaskSchedule,
            root: state.userRoot,
            task: state.userTask,
            taskSchedule: state.userTaskSchedule,
        }
    },
}

const mutations = {
    removeUser (state) {
        localStorage.removeItem('user-id')
        localStorage.removeItem('user-manager')
        localStorage.removeItem('user-marketing-task')
        localStorage.removeItem('user-marketing-task-schedule')
        localStorage.removeItem('user-root')
        localStorage.removeItem('user-task')
        localStorage.removeItem('user-task-schedule')
        state.userID = null
        state.userManager = null
        state.userMarketingTask = null
        state.userMarketingTaskSchedule = null
        state.userRoot = null
        state.userTask = null
        state.userTaskSchedule = null
    },
    updateUser (state, user) {
        localStorage.setItem('user-id', user.id)
        localStorage.setItem('user-manager', user.manager)
        localStorage.setItem('user-marketing-task', user.marketingTask)
        localStorage.setItem('user-marketing-task-schedule', user.marketingTaskSchedule)
        localStorage.setItem('user-root', user.root)
        localStorage.setItem('user-task', user.task)
        localStorage.setItem('user-task-schedule', user.taskSchedule)
        state.userID = user.id
        state.userManager = user.manager
        state.userMarketingTask = user.marketingTask
        state.userMarketingTaskSchedule = user.marketingTaskSchedule
        state.userRoot = user.root
        state.userTask = user.task
        state.userTaskSchedule = user.taskSchedule
    },
    updateUserID (state, id) {
        localStorage.setItem('user-id', id)
        state.userID = id
    },
    updateUserManager (state, manager) {
        localStorage.setItem('user-manager', manager)
        state.userManager = manager
    },
    updateUserMarketingTask (state, task) {
        localStorage.setItem('user-marketing-task', task)
        state.userMarketingTask = task
    },
    updateUserMarketingTaskSchedule (state, task) {
        localStorage.setItem('user-marketing-task-schedule', task)
        state.userMarketingTaskSchedule = task
    },
    updateUserRoot (state, root) {
        localStorage.setItem('user-root', root)
        state.userRoot = root
    },
    updateUserTask (state, task) {
        localStorage.setItem('user-task', task)
        state.userTask = task
    },
    updateUserTaskSchedule (state, task) {
        localStorage.setItem('user-task-schedule', task)
        state.userTaskSchedule = task
    },
}

export default {
    state,
    getters,
    mutations,
}
